module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/3/video-preview-2-ed85231502df262d34f86cbcb5fec714.png";